import { useCallback, useRef } from 'react';

/**
 * Wraps an async function so that calls made while a previous call is still
 * pending are ignored. Disabled buttons alone are not enough: two clicks can
 * land before React re-renders the disabled state.
 *
 * @template {(...args: any[]) => Promise<any>} F
 * @param {F} fn
 * @returns {(...args: Parameters<F>) => Promise<Awaited<ReturnType<F>>|undefined>}
 */
export default function useSingleFlight(fn) {
  const inFlight = useRef(false);
  const fnRef = useRef(fn);
  fnRef.current = fn;

  return useCallback(async (...args) => {
    if (inFlight.current) return undefined;
    inFlight.current = true;
    try {
      return await fnRef.current(...args);
    } finally {
      inFlight.current = false;
    }
  }, []);
}
